import Vue from 'vue'
import MLoading from '@/components/MLoading'
Vue.use(MLoading)
